export const eventTypes = {
  click: "click",
  filter: "filter",
  page_view: "page_view"
};

export const logEvent = (type, data) => {
  if (!type || !eventTypes[type]) {
    throw new Error(`Event is not registered. Please add it to eventTypes`);
  }
  window.gtag("event", type, data);
};
